<p-dialog
  header="Nueva Ciudad"
  [(visible)]="visible"
  [modal]="true"
  (onHide)="closeDialog()"
  [closable]="true"
  [style]="{ width: '25%', height: '43vh' }"
>
  <div class="loading-spinner" *ngIf="isLoading">
    <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
  </div>

  <div class="flex flex-column gap-3 mb-3" *ngIf="!isLoading">
    <div class="field">
      <label for="country" class="font-semibold">País</label>
      <p-autoComplete
        id="country"
        [(ngModel)]="selectedCountry"
        [suggestions]="filteredOptions"
        (completeMethod)="filterOptions($event, 'country')"
        (input)="onChangeInput($event, 'country')"
        [dropdown]="true"
        [disabled]="true"
        [forceSelection]="true"
        [placeholder]="'Selecciona un país'"
        (onSelect)="onSelect($event, 'country')"
        [style]="{ width: '100%' }"
        [field]="'text'"
      ></p-autoComplete>
      <div
        *ngIf="!selectedCountry && hasInteracted['country']"
        class="error-message"
        style="color: red; font-size: 0.875rem; margin-top: 5px"
      >
        Este campo es obligatorio.
      </div>
    </div>
    <br />

    <div class="field">
      <label for="city" class="font-semibold">Ciudad</label>
      <input
        pInputText
        id="city"
        type="text"
        [(ngModel)]="city"
        (ngModelChange)="onChangeInput($event, 'city')"
        [placeholder]="'Ingresa nombre de la ciudad'"
      />
      <div
        *ngIf="!city && hasInteracted['city']"
        style="color: red; font-size: 0.875rem; margin-top: 5px"
      >
        Este campo es obligatorio.
      </div>
    </div>
  </div>

  <div
    style="display: flex; justify-content: center; gap: 10px; margin-top: 10px"
  >
    <button
      type="button"
      pButton
      label="Registrar"
      [disabled]="isDisabled"
      (click)="onRegister()"
      class="btn"
    ></button>
  </div>
</p-dialog>
